import { Component, Inject } from '@angular/core';
import { DialogData } from '../user-nif-code-form.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'user-nif-code-example',
    templateUrl: './user-nif-code-example.component.html',
    styleUrls: ['./user-nif-code-example.component.scss'],
    standalone: false
})
export class UserNifCodeExampleComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}
}
